import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  provider: `apple` | `google`;
  idToken?: string | null | undefined;
  expiresAt?: number | null | undefined;
  errorMessage?: string | null | undefined;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class OAuthFailed extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const {
      provider,
      idToken,
      expiresAt,
      errorMessage,
      ...baseArgs
    } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.AUTH,
      type: `OAUTH_FAILED`,
      data: {
        provider,
        idToken,
        expiresAt,
        errorMessage
      },
    });
  }
}

export { OAuthFailed };
